import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;

    console.log("PWA install outcome:", result.outcome);

    setDeferredPrompt(null);
    setShowButton(false);
  };

  if (!showButton) return null;

  return (
    <Button
      variant="outlined"
      onClick={handleInstall}
      style={{
        color: "white",
        borderColor: "white",
        marginLeft: "10px",
        borderRadius: "20px",
        fontWeight: "bold",
        padding: "4px 14px",
        textTransform: "none",
      }}
    >
      Install App
    </Button>
  );
};

export default InstallPWAButton;
